import Project from '../components/Project';

function Projects() {
    return <div id="projects" className="py-20 px-5 xl:px-36">
        <div className="flex pb-10">
            <h1 className="text-2xl font-bold">MY PROJECTS</h1>
            <div className="block relative border-t border-black -bottom-5 ml-3 w-full max-w-screen-sm">&nbsp;</div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            <Project 
                title="National Day Parade Data Tracking Website" 
                description="A full-stack website for tracking data collection during the National Day Parade and its rehearsals." 
                technologies={["React", "NodeJS", "MySQL"]}
                link="https://github.com/Ruin9999/ndp-bus-tracking"
            />
            <Project 
                title="Leetcode API" 
                description="A RESTful API for simple interaction with Leetcode." 
                technologies={["Typescript","ExpressJS", "NodeJS", "Axios"]}
                link="https://github.com/Ruin9999/leetcode-api"
            />
            <Project 
                title="Minecraft Bot" 
                description="A Simple Web Application for minecraft automation and control in the browser." 
                technologies={["NodeJS", "ElectronJS"]}
                link="https://github.com/Ruin9999/minecraft-bot"
            />
            <Project 
                title="Discord Bot" 
                description="Building a custom multisite compatible wordpress plugin to build global search with Algolia." 
                technologies={["React", "NodeJS"]}
                link="https://github.com/Ruin9999/yet-another-discord-bot"
            />
            <Project 
                title="Bookio Website" 
                description="Full stack website built for a made up company called 'Bookio'. Along with simple cookie authentication and paypal integration." 
                technologies={["PHP", "MySQL", "HTML", "CSS", "JavaScript"]}
                link="https://github.com/Ruin9999/csad-website"
            />
            <Project 
                title="Discord Bot Template" 
                description="My Attempt at object orientated programming to make more modular and maintainable code." 
                technologies={["Typescript", "NodeJS"]}
                link="https://github.com/Ruin9999/discord-bot-template"
            />
        </div>
    </div>
}

export default Projects;